module.exports = __webpack_public_path__ + "static/media/marker-small.0ed8de96.svg";